export default __webpack_public_path__ + "static/media/fleshka77.895b0ab3.png";